import React, { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { IconButton } from "../../Ui/index.jsx";

// Light or dark. The choice is remembered; with none set the app follows the OS (resolved by the script in index.html
// before the first paint).
export function ThemeToggle() {
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute("data-theme") || "light");
  const next = theme === "dark" ? "light" : "dark";
  const choose = () => {
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem("atg-theme", next); } catch { /* private mode */ }
    setTheme(next);
  };
  return (
    <IconButton label={`Switch to ${next} mode`} onClick={choose}>
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </IconButton>
  );
}
